// extracted by mini-css-extract-plugin
module.exports = {"order-summary-card":"OrderSummaryCard_order-summary-card__1rx47","order-summary-image":"OrderSummaryCard_order-summary-image__fF7Sr"};